<template>
  <div class="pa-2">
    <v-tabs v-model="tab" slider-color="primary">
      <v-tab :key="'status-board'" ripple :href="'#StatusBoard'">สถานะ</v-tab>
      <v-tab :key="'customers'" ripple :href="'#Customers'">ลูกค้า</v-tab>
      <v-tab :key="'admin'" ripple :href="'#Admin'">แอดมิน</v-tab>
    </v-tabs>
    <component :is="tab"></component>
  </div>
</template>

<script>
import Customers from './Customers'
import Admin from './Admin'
import StatusBoard from './StatusBoard'
export default {
  data() {
    return {
      tab: null
    }
  },
  components: {
    Customers,
    Admin,
    StatusBoard
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/view/template/qualityexpress/main.vue